export function setCookie(name, value, opts = {}) {
    const { days = 7, path = "/", domain, secure = true, sameSite = "Lax", } = opts;
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
    if (domain)
        cookie += `; Domain=${domain}`;
    if (secure)
        cookie += `; Secure`;
    //console.log('cookie', cookie);
    document.cookie = cookie;
}
export function getCookie(name) {
    const key = encodeURIComponent(name) + "=";
    const parts = document.cookie.split("; ").map(v => v.trim());
    for (const p of parts) {
        if (p.startsWith(key))
            return decodeURIComponent(p.slice(key.length));
    }
    return null;
}
export function deleteCookie(name, opts = {}) {
    // Expire it
    setCookie(name, "", { days: -1, path: opts.path ?? "/", domain: opts.domain, secure: true, sameSite: "Lax" });
}
